/**
 * 通知相关 API
 */

import { get, post, del } from './request';

/** 通知类型 */
export type NotificationType = 'feedback_reply' | 'task_failed' | 'system';

/** 通知项 */
export interface NotificationItem {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  content: string | null;
  link: string | null;
  refId: string | null;
  isRead: boolean;
  createdAt: string;
}

/** 通知列表响应 */
export interface NotificationListResponse {
  list: NotificationItem[];
  total: number;
  page: number;
  pageSize: number;
}

/** 未读数量响应 */
export interface UnreadCountResponse {
  count: number;
}

/**
 * 获取通知列表
 */
export function getNotifications(params?: { page?: number; pageSize?: number }) {
  return get<NotificationListResponse>('/notifications', params);
}

/**
 * 获取未读通知数量
 */
export function getUnreadCount() {
  return get<UnreadCountResponse>('/notifications/unread-count');
}

/**
 * 标记单条通知为已读
 */
export function markAsRead(id: string) {
  return post<null>(`/notifications/${id}/read`);
}

/**
 * 标记所有通知为已读
 */
export function markAllAsRead() {
  return post<null>('/notifications/read-all');
}

/**
 * 删除通知
 */
export function deleteNotification(id: string) {
  return del<null>(`/notifications/${id}`);
}
